<div matDialogTitle>Create Asset from Transactions</div>
<span class="centered text-padding">{{transactions.length === 1 ? '' : 'All'}}
    <span class="bold-text">{{transactions.length}}</span>
    transaction{{transactions.length === 1 ? '' : 's'}} selected will be linked to the asset
</span>
<ah-update-trx-form [inputFields]="inputFields" [transactions]="transactions"
    [characters]="characters$ | async" [sets]="sets$ | async" [departments]="departments$ | async"
    [subDepartments]="subDepartments$ | async" [locations]="locations$ | async"
    [dispositions]="dispositions$ | async" [excludedDispositions]="excludedDispositions$ | async"
    [franchise]="franchise" [projects]="projects$ | async" [projectCurrencies]="projectCurrencies$ | async"
    [indexType]="indexType" (close)="close()">
</ah-update-trx-form>
